// Nudge authors who submit an embed page with no accessibility alternative:
// no text alternative (Description or Info) and no source link. A user relying
// on a screen reader, or unable to use touch gestures, would then have no way
// to reach the embedded content, so we ask for confirmation before saving.

const hasText = (html) =>
  (html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim().length > 0

const anyFilled = (form, nameFragment) =>
  Array.from(form.querySelectorAll(`textarea[name*="${nameFragment}"]`)).some((field) =>
    hasText(field.value),
  )

const confirmAccessibilityAlternative = (event, form, sourceInput) => {
  // Flush CKEditor content back into the textareas before we read them.
  if (window.CKEDITOR && window.CKEDITOR.instances) {
    Object.keys(window.CKEDITOR.instances).forEach((name) => {
      window.CKEDITOR.instances[name].updateElement()
    })
  }

  const hasAlternative = anyFilled(form, "[description_multi]") || anyFilled(form, "[info_multi]")
  const hasSourceLink = sourceInput.value.trim().length > 0
  if (hasAlternative || hasSourceLink) return

  const proceed = window.confirm(
    "This embed has no accessibility alternative yet.\n\n" +
      "Add a text alternative in the Description or Info field, or a source link, " +
      "so screen-reader users and people who cannot use touch gestures can reach the same information.\n\n" +
      "Are you sure you want to continue without providing accessibility adjustments?",
  )

  if (!proceed) {
    event.preventDefault()
    event.stopPropagation()
  }
}

const attachConfirmHandler = () => {
  const sourceInput = document.getElementById("embed_page_source_url")
  if (!sourceInput || !sourceInput.form) return
  const form = sourceInput.form

  form.addEventListener("submit", (event) => {
    confirmAccessibilityAlternative(event, form, sourceInput)
  })
}

// Attach immediately if the DOM is already parsed, otherwise wait for it.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", attachConfirmHandler)
} else {
  attachConfirmHandler()
}
